import React from 'react';
import { FileText, ArrowRight } from 'lucide-react';

/** SectionCaseStudiesItem – Single case study card: title, description, and "Read more" link to child detail. */
export default function SectionCaseStudiesItem({ title, description, href, date, internal }) {
  const isInternal = internal || (href && href.startsWith('#'));
  return (
    <a
      href={href}
      {...(!isInternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      className="block p-5 rounded-xl border transition-all hover:border-cyan/40 group h-full flex flex-col"
      style={{ background: 'var(--jb-forest-card)', borderColor: 'var(--jb-border)' }}
    >
      <div className="flex gap-3 flex-1">
        <div className="flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center text-cyan" style={{ background: 'var(--jb-cyan-dim)' }}>
          <FileText className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-display font-bold text-text-hero group-hover:text-cyan transition">{title}</h3>
          {description && <p className="font-body text-text-sub text-sm mt-1 line-clamp-2">{description}</p>}
          {date && <p className="font-mono text-text-muted text-xs mt-2">{date}</p>}
        </div>
      </div>
      <span className="inline-flex items-center gap-1 mt-4 text-cyan text-sm font-semibold group-hover:gap-2 transition-all">
        Read more <ArrowRight className="w-4 h-4" />
      </span>
    </a>
  );
}
